module.exports = __webpack_public_path__ + "img/warning.4f293455.svg";